import { apiSlice } from "api/api.slice";
import type { IdArg } from "api/api.types";
import { dimensionIdGetSchema, getDimensionsResultSchema } from "api/schemas/dimensionApiSchema";
import { toSearchString } from "api/utils";

export type GetDimensionsArg = { limit?: number; offset: number; page?: "search"; search?: string };

export const dimensionsApiSlice = apiSlice.injectEndpoints({
  endpoints: (build) => ({
    getDimension: build.query({
      query: ({ id }: IdArg) => ({ headers: { "x-api-version": "v2" }, url: `/dimension/${id}` }),
      responseSchema: dimensionIdGetSchema,
    }),
    getDimensions: build.query({
      query: ({ limit, offset, page, search }: GetDimensionsArg) => ({
        headers: { "x-api-version": "v2" },
        url: `/dimension${toSearchString({ has_parent: "true", limit, offset, page, search, statuses: "Active" })}`,
      }),
      responseSchema: getDimensionsResultSchema,
    }),
  }),
});

export const { useGetDimensionQuery, useGetDimensionsQuery, useLazyGetDimensionQuery, useLazyGetDimensionsQuery } =
  dimensionsApiSlice;
